const Filter = require('../../../shared/ctxFiltersPanel/ctxFilterModel');
const { permissions } = require('../../constants/permissions');
const Report = require('../../model/Report');
const TableState = require('../../model/TableState');

const dependencies = ['$q', '$filter', '$rootScope', 'storageService', 'crudService', 'utilsService', 'notificationService', 'sharedPersistenceService', 'iamPersistenceService'];
class ReportsPersistenceService {
    constructor() {
        require('../../../shared/utils/injectDeps')(this, arguments);
        this.REST_ENDPOINTS = this.sharedPersistenceService.getRestEndpoints();
        this.datetimeLocaleFormat = this.utilsService.getDateTimeLocaleFormat(true);
        this.initFilter();

        this.$rootScope.$on("logout", () => {
            this.reportTableState = undefined;
            this.storageService.clearCustomPageSize('reports');
            this.filters.forEach((filter) => {
                filter.clear();
            });
        });
        this.$rootScope.$on("force-logout", () => {
            this.reportTableState = undefined;
            this.storageService.clearCustomPageSize('reports');
            this.filters.forEach((filter) => {
                filter.clear();
            });
        });
        this.$rootScope.$on('userGroup.changed', () => {
            if (this.reportTableState) this.reportTableState.page = 1;
            this.storageService.clearCustomPageSize('reports');
            this.filters.forEach((filter) => {
                filter.clear();
            });
        });
    }

    initFilter() {
        this.filters = [];

        if (this.utilsService.isBackUpAdmin) {
            this.filters.push(Filter.getSearchFilter(this.$filter('translate')('report.filters.name'), Report.getNameKey(), 'name'));
            this.filters.push(Filter.getCheckboxFilter(this.$filter('translate')('report.filters.scheduled'), Report.getScheduledKey(), Report.getScheduledOptions(), 'scheduled'));
        }
    }

    load(firstPage, filters, isExport) {
        if (!this.iamPersistenceService.hasPermissions(permissions.REPORT_LISTING)) {
            return this.$q((resolve) => { resolve([]) })
        }

        let tableState, tempPageSize;
        if (firstPage && this.reportTableState) {
            this.reportTableState.page = 1;
        }
        // check if custom pageSize is set
        tempPageSize = this.storageService.getCustomPageSize('reports');
        if (tempPageSize && !this.reportTableState) {
            tableState = new TableState();
            tableState.pageSize = tempPageSize
        }
        return this.crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.REPORTS_REST, this.reportTableState ? this.reportTableState : tableState, this.filters, null, null, null, isExport).then(res => {
            this.reportTableState = res.data.tableState;
            // set pageSize value
            if (this.reportTableState && this.reportTableState.pageSize) this.storageService.setCustomPageSize('reports', this.reportTableState.pageSize);
            return res.data.entities.map(Report.fromRaw);
        });
    }

    getAllReports(firstPage, filters, isExport) {
        let tableState = new TableState();
        tableState.pageSize = 1000000;
        tableState.searchBy = this.reportTableState.searchBy;
        return this.crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.REPORTS_REST, tableState, this.filters, null, null, null, isExport).then(res => {
            return res.data.entities.map(Report.fromRaw);
        })
    }

    getReport(report, firstPage) {
        if (firstPage && this.reportVersionTableState) {
            this.reportVersionTableState.page = 1;
            this.reportVersionTableState.pageSize = 10;
        }
        return this.crudService.getPagedWithStructuredFilter(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}`, this.reportVersionTableState, []).then(res => {
            this.reportVersionTableState = res.data.tableState;
            return res.data.entities;
        });
    }
    getReportData(reportData, report = null, tags = null) {
        const reportUuid = report ? `&reportUuid=${report.uuid}` : '';
        const dataTags = tags.tags && tags.tags.length ? `&tags=${tags.tags.join(',')}` : '';
        const parameter = reportData ? `?timeRange=${reportData}` : '';
        return this.crudService.get(this.REST_ENDPOINTS.REPORTS_REST + '/data' + parameter + reportUuid + dataTags);
    }

    getNewReportData(data, timeRange) {
        const tagsList = data ? '&tags=' + data.tags.join(',') : '';
        const parameter = timeRange ? `?timeRange=${timeRange}` : '';
        return this.crudService.get(this.REST_ENDPOINTS.REPORTS_REST + '/data' + parameter + tagsList);
    }

    createReport(report) {
        return this.crudService.post(this.REST_ENDPOINTS.REPORTS_REST, report);
    }

    updateReport(report, data) {
        return this.crudService.put(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}`, data,);
    }

    delReport(report) {
        return this.crudService.del(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}`);
    }

    getReportVersion(report, version) {
        return this.crudService.get(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/versions' + `/${encodeURI(version)}`);
    }

    createReportVersion(report, data) {
        return this.crudService.post(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/versions', data);
    }

    deleteReportVersion(report, version) {
        return this.crudService.del(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/versions' + `/${encodeURI(version.uuid)}`);
    }

    exportReportVersion(report, version, data) {
        return this.crudService.exportFilePdf(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/versions/' + version + '/export' + `/${data.format}` + `/${data.lang}` + `?timezone=${encodeURI(data.timezone)}`);
    }

    getScheduleReport(report) {
        //const reportUuid = report ? '${report.uuid}' : '';
        return this.crudService.get(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/schedules');
    }

    createScheduleReport(report, data) {
        return this.crudService.post(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}/schedules`, data);
    }

    updateScheduleReport(report, data) {
        return this.crudService.put(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/schedules', data);
    }

    unscheduleReport(report, data) {
        return this.crudService.del(this.REST_ENDPOINTS.REPORTS_REST + `/${encodeURI(report.uuid)}` + '/schedules');
    }


    getReportTags() {
        return this.crudService.get(this.REST_ENDPOINTS.REPORTS_REST + `/tags`).then(res => {
            return res.data.entities;
        });
    }

}

ReportsPersistenceService.$inject = dependencies;

module.exports = ReportsPersistenceService;


// WEBPACK FOOTER //
// ./src/azurebackup/views/reports/reports.persistence.service.js